var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclusionActivity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.5H10.3183C10.6339 2.5 10.9225 2.67833 11.0637 2.96066L11.6667 4.16667H16.6667C17.1269 4.16667 17.5 4.53977 17.5 5V14.1667C17.5 14.6269 17.1269 15 16.6667 15H11.3483C11.0328 15 10.7442 14.8217 10.603 14.5393L10 13.3333H4.16667V18.3333H2.5V2.5Z",
    fill: "#9CA2A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclusionActivity);
export default __webpack_public_path__ + "static/media/exclusion-activity.f790cad95c705700a471a7256b4937ed.svg";
export { ForwardRef as ReactComponent };